import type { QuasarLanguage } from 'quasar';
import { Quasar } from 'quasar';
import ENG from 'quasar/lang/en-US.js';
import KG from 'quasar/lang/kk.js';
import RU from 'quasar/lang/ru.js';
import CN from 'quasar/lang/zh-CN.js';

const language = {
  RU,
  ENG,
  KG,
  CN,
};

function* modifyLanguageMonths(newDate: string[][]) {
  language.KG.date.months = newDate[0] as QuasarLanguage['date']['months'];
  language.KG.date.monthsShort = newDate[1] as QuasarLanguage['date']['monthsShort'];
  language.KG.date.daysShort = newDate[2] as QuasarLanguage['date']['daysShort'];
  yield;
}

const languageModifier = modifyLanguageMonths([
  [
    'Үчтүн айы',
    'Бирдин айы',
    'Жалган Куран',
    'Чын Куран',
    'Бугу',
    'Кулжа',
    'Теке',
    'Баш Оона',
    'Аяк Оона',
    'Тогуздун айы',
    'Жетинин айы',
    'Бештин айы',
  ],
  ['Үчтүн', 'Бир', 'Жал', 'Чын', 'Бугу', 'Кулжа', 'Теке', 'Баш', 'Аяк', 'Тог', 'Жет', 'Беш'],
  ['Жш', 'Дш', 'Шш', 'Шр', 'Бш', 'Жм', 'Иш '],
]);

export function useQuasarLanguage(lang: string) {
  if (lang === 'KG') languageModifier.next();
  Quasar.lang.set(language[lang as keyof typeof language]);
}
